enum EmptyAlertEnum {
	BANK = 'bank',
	ADDRESS = 'address',
	CELL_PHONE = 'cellPhone',
	EMAIL = 'email',
}

export {EmptyAlertEnum};
